var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 8.33325C4.58301 7.87301 4.9561 7.49992 5.41634 7.49992H11.2497C11.7099 7.49992 12.083 7.87301 12.083 8.33325C12.083 8.79349 11.7099 9.16658 11.2497 9.16658H5.41634C4.9561 9.16658 4.58301 8.79349 4.58301 8.33325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833008 8.33325C0.833008 4.19112 4.19087 0.833252 8.33301 0.833252C12.4751 0.833252 15.833 4.19112 15.833 8.33325C15.833 10.1041 15.2193 11.7316 14.1929 13.0147L18.0889 16.9107C18.4144 17.2361 18.4144 17.7637 18.0889 18.0892C17.7635 18.4146 17.2359 18.4146 16.9104 18.0892L13.0144 14.1932C11.7314 15.2195 10.1039 15.8333 8.33301 15.8333C4.19087 15.8333 0.833008 12.4754 0.833008 8.33325ZM8.33301 2.49992C5.11135 2.49992 2.49967 5.11159 2.49967 8.33325C2.49967 11.5549 5.11135 14.1666 8.33301 14.1666C11.5547 14.1666 14.1663 11.5549 14.1663 8.33325C14.1663 5.11159 11.5547 2.49992 8.33301 2.49992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.3a12432f57a92495d47e9a33aeb296f6.svg";
export { ForwardRef as ReactComponent };